import {client} from '../axios/client';
import {agentsType} from '../reducers/agents/agentsTypes';
import {types} from "../types/types";

export const updateAgentAvailabilityApi = (id, token, disponibility) => {
    return (dispatch, getState) => {
        return client.patch(`/agents/${id}/status`,
            {agent_disponibility: disponibility},
            {headers: {Authorization: `Bearer ${token}`}}
        ).then(({data}) => {
            if (data.agent_disponibility !== disponibility) {
                throw new Error(
                    `La disponibilidad no se actualizó correctamente. Esperado: ${disponibility}, recibido: ${data.agent_disponibility}`
                );
            }
            const currentAgent = getState().agent;
            dispatch({
                type: types.agentUpdate,
                payload: {...currentAgent, agent_disponibility: disponibility}
            });
        }).catch(error => {
            console.error('Error al actualizar disponibilidad del agente:', error);
            throw error;
        });
    };
};

export const getAgentsFromApi = (
    id_customer,
    token,
    offset = 0,
    limit = 20
) => {
    return (dispatch) => {
        client.get(`/agents/list/${id_customer}`,
            {
                params: {
                    offset,
                    limit,
                },
                headers: {'Authorization': `Bearer ${token}`}
            })
            .then(({data}) => {
                const {items, count} = data;
                const customerAgents = {
                    offset,
                    limit,
                    items: items,
                    count
                };
                if (offset === 0){dispatch(getAgents(customerAgents));
                }else{
                    dispatch(addAgents(customerAgents))
                }
            })
    }
}

export const getAgents = (agentes) => ({
    type: agentsType.getAgents,
    payload: agentes
});

export const addAgents = (agentes) => ({
    type: agentsType.addAgents,
    payload: agentes
});


export const loadingAgents = (flag) => ({
    type: agentsType.getAgents,
    payload: flag
});

export const selectIdAgent = (id_agent) => ({
    type: agentsType.selectIdAgent,
    payload: id_agent
})

export const currentChatRoomAgent = (room,agent,contact)=> (
    {
        type:agentsType.agentCurrentChatRoom,
        payload:{room:room,agent:agent,contact:contact}
    }
);
export const closeCurrentChatRoomAgent = ()=> (
    {
        type:agentsType.agentCloseCurrentChatRoom,
        payload:null
    }
);

export const updateAgentPresence = ({ agent_email, online, last_seen }) => ({
    type: agentsType.updateAgentPresence,
    payload: { agent_email, online, last_seen },
});